var map = {
	"./Accordion.svg": 470,
	"./Breadcrumb.svg": 471,
	"./Button.svg": 472,
	"./Checkbox.svg": 473,
	"./Code snippet.svg": 474,
	"./Content switcher.svg": 475,
	"./Data table.svg": 476,
	"./Date picker.svg": 477,
	"./Dropdown.svg": 478,
	"./File uploader.svg": 479,
	"./Form.svg": 480,
	"./Inline loading.svg": 481,
	"./Link.svg": 482,
	"./List.svg": 483,
	"./Loading.svg": 484,
	"./Modal.svg": 485,
	"./Multiselect.svg": 486,
	"./NoImage.svg": 308,
	"./Notification.svg": 487,
	"./Number input.svg": 488,
	"./Overflow menu.svg": 489,
	"./Pagination.svg": 490,
	"./Progress indicator.svg": 491,
	"./Radio button.svg": 492,
	"./Search.svg": 493,
	"./Select.svg": 494,
	"./Slider.svg": 495,
	"./Structured list.svg": 496,
	"./Tabs.svg": 497,
	"./Tag.svg": 498,
	"./Text input.svg": 499,
	"./Tile.svg": 500,
	"./Toggle.svg": 501,
	"./Tooltip.svg": 502,
	"./UI shell.svg": 503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 469;